"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _recompose = require("recompose");

var _styles = require("@material-ui/core/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["children", "classes", "disableShadow", "docked", "open", "width", "shift", "setActionBarContainerNode"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      flexShrink: 0,
      height: '100%',
      boxShadow: theme.shadows[12],
      zIndex: theme.zIndex.drawer,
      overflow: 'visible'
    },
    disableShadow: {
      boxShadow: 'none'
    },
    rootOverlay: {
      position: 'fixed',
      top: 0,
      right: 0
    },
    openOverlay: {
      opacity: 1,
      transform: 'translate3D(0, 0, 0)',
      transition: theme.transitions.create(['transform', 'opacity'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    closedOverlay: {
      opacity: 0,
      transform: 'translate3D(100%, 0, 0)',
      transition: theme.transitions.create(['transform', 'opacity'], {
        easing: theme.transitions.easing.easeIn,
        duration: theme.transitions.duration.leavingScreen
      })
    },
    openDocked: {
      opacity: 1,
      transition: theme.transitions.create(['width', 'transform', 'opacity'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.shorter
      })
    },
    closedDocked: {
      width: '0 !important',
      opacity: 0,
      transition: theme.transitions.create(['width', 'transform', 'opacity'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.shorter
      })
    },
    childrenContainer: {
      height: '100%',
      backgroundColor: theme.palette.background["default"]
    },
    shift: {}
  };
}; // A view that can open and close
// Can be docked or in overlay


var DetailView = /*#__PURE__*/function (_Component) {
  _inherits(DetailView, _Component);

  var _super = _createSuper(DetailView);

  function DetailView() {
    _classCallCheck(this, DetailView);

    return _super.apply(this, arguments);
  }

  _createClass(DetailView, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          classes = _this$props.classes,
          disableShadow = _this$props.disableShadow,
          docked = _this$props.docked,
          open = _this$props.open,
          width = _this$props.width,
          shift = _this$props.shift,
          setActionBarContainerNode = _this$props.setActionBarContainerNode,
          other = _objectWithoutProperties(_this$props, _excluded);

      var rootClassNames = (0, _classnames["default"])(classes.rootOverlay, open && classes.openOverlay, !open && classes.closedOverlay);

      if (docked) {
        rootClassNames = (0, _classnames["default"])(open && classes.openDocked, !open && classes.closedDocked);
      }

      var style = {// width,
      };

      if (shift) {
        rootClassNames = (0, _classnames["default"])(rootClassNames, classes.shift);
        style = _objectSpread(_objectSpread({}, style), {}, {
          transform: "translateX(".concat(-shift, "px)")
        });
      }

      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        className: (0, _classnames["default"])(classes.root, rootClassNames, disableShadow && classes.disableShadow),
        style: style
      }, other), /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.childrenContainer,
        style: {
          width: width
        }
      }, children, /*#__PURE__*/_react["default"].createElement("div", {
        className: "actionbar-wrapper",
        ref: setActionBarContainerNode
      })));
    }
  }]);

  return DetailView;
}(_react.Component);

_defineProperty(DetailView, "propTypes", {
  children: _propTypes["default"].node.isRequired,
  classes: _propTypes["default"].object.isRequired,
  disableShadow: _propTypes["default"].bool,
  docked: _propTypes["default"].bool,
  open: _propTypes["default"].bool,
  setActionBarContainerNode: _propTypes["default"].func.isRequired,
  shift: _propTypes["default"].number,
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
});

_defineProperty(DetailView, "defaultProps", {
  docked: false,
  open: false,
  disableShadow: false,
  shift: 0
});

var _default = (0, _recompose.compose)((0, _styles.withStyles)(styles))(DetailView);

exports["default"] = _default;